<template>
  <div
    class="comp-svg-hover"
    @mouseover="active = false"
    @mouseleave="active = true"
  >
    <svg
      v-if="active"
      :style="style"
      :class="['iconfont', initialName]"
      aria-hidden="true"
    >
      <use :xlink:href="initialName"></use>
    </svg>
    <svg
      v-else
      :style="style"
      :class="['iconfont', hoverName]"
      aria-hidden="true"
    >
      <use :xlink:href="hoverName"></use>
    </svg>
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'IconfontHover',
  components: {},
  props: {
    initialName: {
      type: String,
      default: '#icon-video-stop'
    },
    hoverName: {
      type: String,
      default: '#icon-video-stop-hover'
    },
    width: {
      type: String,
      default: '50px'
    },
    height: {
      type: String,
      default: '50px'
    }
  },
  data() {
    return {
      active: true
    };
  },
  computed: {
    style() {
      return {
        width: this.width,
        height: this.height
      };
    }
  },
  async mounted() {},
  methods: {}
};
</script>

<style scoped lang="scss">
/* @import url(); 引入css类 */
.comp-svg-hover {
  cursor: pointer;
  display: inline-block;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  &:hover {
    p {
      color: #2f57fd;
    }
  }
}
.iconfont {
  display: inherit;
  width: 16px;
  // height: 16px;
  // position: absolute;
  // left: 0;
  // top: 0;
  // right: 0;
  // bottom: 0;
  // margin: auto;
}
</style>
